import React, { useState } from "react";
import CustomModal from "../../../../components/common/Modal";
import CustomTable from "../../../../components/common/CustomTable";
import CustomToggleSwitch from "../../../../components/common/CustomToggle";
import CustomDropdown from "../../../../components/common/CustomDropdown/CustomDropdown";
import { useSelector, useDispatch } from "react-redux";
import CustomInput from "../../../../components/common/CustomInput/CustomInput";
import {
   addVendorChildAsync,
   updateVendorChildAsync,
} from "../../../../redux/features/vendorMaster";
import { useFormik } from "formik";
import * as yup from "yup";
import { backdropLoadingAction } from "../../../../redux/features/helperSlice";
import toast from "react-hot-toast";
import { BsPencilSquare } from "react-icons/bs";
import validation from "../../../../helpers/validation";

const validationSchema = yup.object().shape({
   id: yup.string().required("Lane name is required."),
   expressRate: validation.amount("express rate"),
   superExpressRate: validation.amount("Super express rate"),
   destinationRate: validation.amount("destination rate"),
   loadingRate: validation.amount("loading rate"),
   unLoadingRate: validation.amount("Unloading rate"),
   loadingCharges: validation.amount("Loading charges"),
   unloadingCharges: validation.amount("Unloading charges"),
   miscellaneousCarges: validation.amount("Miscellaneous charges"),
   miscellaneousRemarks: yup.string().required("Miscellaneous remarks are required."),
   tripRate: validation.amount("Trip rate"),
});

const EditLaneDetails = ({ data, vendorId, setIsChildUpdated }) => {
   const [showModal, setshowModal] = useState(false);
   const [isChecked, setIsChecked] = useState(true);
   const [mode, setMode] = useState("edit");

   const dispatch = useDispatch();

   const vendorMaster = useSelector((state) => state.vendorMaster);
   // For lane dropdown
   const laneData = vendorMaster?.laneData?.map((item) => ({
      label: item?.name,
      value: item?.id,
   }));

   const handleCloseModal = () => {
      resetForm();
      setshowModal(false);
   };

   const toggleSwitch = () => {
      setIsChecked((prev) => !prev); // Toggle the state
   };

   // Edit Btton Handler
   const editHandler = (data) => {
      setMode("edit");
      setValues({
         expressRate: data?.cust_express_mode_rate_additional,
         superExpressRate: data?.cust_super_express_mode_rate_additional,
         destinationRate: data?.cust_detention_rate_additional,
         loadingRate: data?.cust_multiple_loading_location_rate_additional,
         unLoadingRate: data?.cust_multiple_unloading_location_rate_additional,
         loadingCharges: data?.cust_loading_charges,
         unloadingCharges: data?.cust_unloading_charge,
         miscellaneousCarges: data?.cust_miscellaneous_charges,
         miscellaneousRemarks: data?.cust_miscellaneous_remarks,
         tripRate: data?.vend_trip_rate,
         id: data?.id,
      });
      setshowModal(true);
   };

   // Add button handler
   const addButtonHandler = () => {
      setshowModal(true);
      setMode("add");
      resetForm();
   };

   // Update api call
   const updateLane = (formData) => {
      dispatch(backdropLoadingAction(true));
      const newData = new FormData();
      newData.append("vendor_master_id", vendorId);
      newData.append("lane_master_id", formData.id);
      newData.append("_method", "PATCH");
      newData.append("model_id", 7);
      newData.append("action_id", 2);

      // for array of elements
      const ard = {
         vend_express_mode_rate_additional: formData.expressRate,
         vend_super_express_mode_rate_additional: formData.superExpressRate,
         vend_multiple_loading_location_rate_additional: formData.loadingRate,
         vend_multiple_unloading_location_rate_additional: formData.unLoadingRate,
         vend_loading_charges: formData.loadingCharges,
         vend_unloading_charge: formData.unloadingCharges,
         vend_detention_rate_additional: formData.destinationRate,
         vend_miscellaneous_charges: formData.miscellaneousCarges,
         vend_miscellaneous_remarks: formData.miscellaneousRemarks,
         vend_trip_rate: formData.tripRate,
      };

      Object.keys(ard).forEach((key, index) => {
         newData.append(`${key}[]`, ard[key]);
      });

      dispatch(
         updateVendorChildAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               setIsChildUpdated(true);
               handleCloseModal();
               toast.success("Updated successfully.");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   // Add api call
   const addLane = (formData) => {
      dispatch(backdropLoadingAction(true));
      const newData = new FormData();
      newData.append("vendor_master_id", vendorId);
      newData.append("lane_master_id[]", formData.id);
      newData.append("model_id", 7);
      newData.append("action_id", 1);

      // for array of elements
      const ard = {
         vend_express_mode_rate_additional: formData.expressRate,
         vend_super_express_mode_rate_additional: formData.superExpressRate,
         vend_multiple_loading_location_rate_additional: formData.loadingRate,
         vend_multiple_unloading_location_rate_additional: formData.unLoadingRate,
         vend_loading_charges: formData.loadingCharges,
         vend_unloading_charge: formData.unloadingCharges,
         vend_detention_rate_additional: formData.destinationRate,
         vend_miscellaneous_charges: formData.miscellaneousCarges,
         vend_trip_rate: formData.tripRate,
      };

      Object.keys(ard).forEach((key, index) => {
         newData.append(`${key}[]`, ard[key]);
      });
      dispatch(
         addVendorChildAsync({
            data: newData,
            done: () => {
               dispatch(backdropLoadingAction(false));
               handleCloseModal();
               setIsChildUpdated(true);
               toast.success("Added successfully.");
            },
            err: (error) => {
               dispatch(backdropLoadingAction(false));
               //toast.error(error);
            },
         }),
      );
   };

   const formik = useFormik({
      initialValues: {
         expressRate: "",
         superExpressRate: "",
         destinationRate: "",
         loadingRate: "",
         unLoadingRate: "",
         loadingCharges: "",
         unloadingCharges: "",
         miscellaneousCarges: "",
         miscellaneousRemarks: "",
         tripRate: "",
         id: "",
      },
      validationSchema,
      onSubmit: mode === "edit" ? updateLane : addLane,
   });

   const {
      touched,
      errors,
      values,
      setValues,
      getFieldProps,
      setFieldValue,
      handleSubmit,
      resetForm,
   } = formik;

   const columns = [
      {
         name: "Lane Name",
         selector: (row) => row.name,
         sortable: true,
      },
      {
         name: `Express Mode Rate Additional`,
         selector: (row) => row.cust_express_mode_rate_additional,
      },
      {
         name: "Super Express Mode Rate Additional",
         selector: (row) => row.cust_super_express_mode_rate_additional,
      },
      {
         name: "Detention Rate Additional",
         selector: (row) => row.cust_detention_rate_additional,
      },
      {
         name: "Miscellaneous Remarks",
         selector: (row) => row.cust_miscellaneous_remarks,
      },
      {
         name: "Action",
         width: "9rem",
         selector: (row) => {
            return (
               <div className="d-flex align-items-center">
                  <button className="btn" onClick={() => editHandler(row)}>
                     <BsPencilSquare
                        className="text-primary"
                        style={{ height: "1.5rem", width: "1.5rem" }}
                     />
                  </button>
                  <CustomToggleSwitch
                     checked={isChecked}
                     onChange={toggleSwitch}
                     id="vendor1"
                  />
               </div>
            );
         },
      },
   ];

   return (
      <>
         <CustomModal
            title={mode === "edit" ? "Edit Lane" : "Add Lane"}
            modalSize={"modal-xl"}
            showModal={showModal}
            handleCloseModal={handleCloseModal}
            onSubmit={handleSubmit}
            child={
               <>
                  <div className="row">
                     <div className="col-lg-4">
                        <CustomDropdown
                           require
                           label="Lane Name"
                           optionData={laneData}
                           values={laneData?.filter((lane) => lane.value === values.id)}
                           onChange={(values) => setFieldValue("id", values[0]?.value)}
                           errors={touched?.id && errors?.id}
                           message={errors?.id}
                           disabled={mode === "edit"}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Trip rate"
                           id="tripRate"
                           placeholder="Enter Amount"
                           name="tripRate"
                           {...getFieldProps("tripRate")}
                           errors={touched.tripRate && errors?.tripRate}
                           message={errors?.tripRate}
                        />
                     </div>
                  </div>
                  <div className="row mt-3">
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Express mode rate additional"
                           id="expressModeRateAdditional"
                           placeholder="Enter Amount"
                           name="expressRate"
                           {...getFieldProps("expressRate")}
                           errors={touched.expressRate && errors?.expressRate}
                           message={errors?.expressRate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Super express mode rate additional"
                           id="superExpressModeRateAdditional"
                           placeholder="Enter amount"
                           name="superExpressRate"
                           {...getFieldProps("superExpressRate")}
                           errors={touched.superExpressRate && errors?.superExpressRate}
                           message={errors?.superExpressRate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Detention rate additional"
                           id="detentionRateAdditional"
                           placeholder="Enter amount"
                           name="destinationRate"
                           {...getFieldProps("destinationRate")}
                           errors={touched.destinationRate && errors?.destinationRate}
                           message={errors?.destinationRate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Multiple loading location rate additional"
                           id="multipleLoadingLocationRateAdditional"
                           placeholder="Enter amount"
                           name="loadingRate"
                           {...getFieldProps("loadingRate")}
                           errors={touched.loadingRate && errors?.loadingRate}
                           message={errors?.loadingRate}
                        />
                     </div>

                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Multiple unloading location rate additional"
                           id="multipleUnloadingLocationRateAdditional"
                           placeholder="Enter amount"
                           name="unLoadingRate"
                           {...getFieldProps("unLoadingRate")}
                           errors={touched.unLoadingRate && errors?.unLoadingRate}
                           message={errors?.unLoadingRate}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Loading charges"
                           id="loadingCharges"
                           placeholder="Enter amount"
                           name="loadingCharges"
                           {...getFieldProps("loadingCharges")}
                           errors={touched.loadingCharges && errors?.loadingCharges}
                           message={errors?.loadingCharges}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="Unloading charge"
                           id="unloadingCharge"
                           placeholder="Enter amount"
                           name="unloadingCharges"
                           {...getFieldProps("unloadingCharges")}
                           errors={touched.unloadingCharges && errors?.unloadingCharges}
                           message={errors?.unloadingCharges}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           inputType="number"
                           require
                           label="miscellaneous charges"
                           id="miscellaneousCharges"
                           placeholder="Enter amount"
                           name={"miscellaneousCarges"}
                           {...getFieldProps("miscellaneousCarges")}
                           errors={
                              touched.miscellaneousCarges && errors?.miscellaneousCarges
                           }
                           message={errors?.miscellaneousCarges}
                        />
                     </div>
                     <div className="col-lg-4">
                        <CustomInput
                           //   inputType="number"
                           require
                           label="miscellaneous Remarks"
                           id="miscellaneousRemarks"
                           placeholder="Enter remarks"
                           name={"miscellaneousRemarks"}
                           {...getFieldProps("miscellaneousRemarks")}
                           errors={
                              touched.miscellaneousRemarks && errors?.miscellaneousRemarks
                           }
                           message={errors?.miscellaneousRemarks}
                        />
                     </div>
                  </div>
               </>
            }
         />
         <div className="d-flex justify-content-between mb-2">
            <h3>Lane Details</h3>
            <button type="button" className="btn btn-primary" onClick={addButtonHandler}>
               <i className="fas fa-plus"></i> Add lane
            </button>
         </div>

         <CustomTable columns={columns} data={data} columnFontSize="14px" />
      </>
   );
};

export default EditLaneDetails;
